"use client";

import { ArrowRight, Clock, Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Contact() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const contactDetails = [{
    icon: <Phone className="size-6 text-primary" />,
    title: "Telefoon",
    value: "+31 85 060 86 68",
    description: "Bel ons voor direct contact",
    action: "tel:+31850608668"
  }, {
    icon: <Mail className="size-6 text-primary" />,
    title: "E-mail",
    value: "info@curanovazorg.nl",
    description: "Wij reageren binnen 24 uur",
    action: "mailto:info@curanovazorg.nl"
  }, {
    icon: <MapPin className="size-6 text-primary" />,
    title: "Werkgebied",
    value: "Regio Den Haag & Rotterdam",
    description: "En omliggende gemeenten",
    action: null
  }, {
    icon: <Clock className="size-6 text-primary" />,
    title: "Openingstijden",
    value: "Maandag tot vrijdag",
    description: "8:00 - 18:00 uur",
    action: null
  }];
  return <section id="contact" ref={sectionRef} className="bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="flex flex-col space-y-8">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground tracking-tight">
                Neem contact met ons op
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed">
                Heeft u vragen over onze persoonsgerichte zorg aan huis? Of wilt u een vrijblijvende kennismaking inplannen? Ons team staat voor u klaar met deskundig advies en een luisterend oor.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {contactDetails.map((detail, i) => <Card key={i} data-index={i} className="bg-card border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300 rounded-2xl overflow-hidden">
                  <CardContent className="p-6 flex flex-col h-full">
                    <div className="bg-primary/10 w-12 h-12 rounded-xl flex items-center justify-center mb-4">
                      {detail.icon}
                    </div>
                    <h3 className="font-semibold text-foreground mb-1">
                      {detail.title}
                    </h3>
                    {detail.action ? <Link to={detail.action} className="text-primary font-medium hover:underline mb-1 inline-block">
                        {detail.value}
                      </Link> : <p className="text-foreground font-medium mb-1">
                        {detail.value}
                      </p>}
                    <p className="text-sm text-muted-foreground mt-auto">
                      {detail.description}
                    </p>
                  </CardContent>
                </Card>)}
            </div>

            <div className="pt-4">
              <Button size="lg" className="rounded-full px-8 text-base h-12" asChild>
                <Link to="tel:+31850608668">
                  Bel ons direct
                  <ArrowRight className="ml-2 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative h-[500px] lg:h-[700px] w-full rounded-[2.5rem] overflow-hidden shadow-xl">
            <div className="absolute inset-0 bg-primary/5 z-10 rounded-[2.5rem]"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576260/img/curanova_friendly_team_member.png" alt="Vriendelijke zorgverlener van CuraNova Zorg" className="absolute inset-0 w-full h-full object-cover object-center" />
            
            {}
            <div className="absolute -bottom-6 -left-6 w-48 h-48 bg-secondary rounded-full blur-3xl opacity-50 z-0 pointer-events-none"></div>
            <div className="absolute -top-6 -right-6 w-64 h-64 bg-primary/20 rounded-full blur-3xl opacity-50 z-0 pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>;
}